// =====================
// IMPORT STYLES & HELPER
// =====================
import "flatpickr/dist/flatpickr.min.css";

import { formatTanggalRange } from "../../helper/formatTanggal.js";
import {
    initTanggalSingleAja,
    initTanggalSingleEnd,
} from "../../helper/flatpickrConfig.js";

import {
    showModalPenjadwalan,
    initReschedule,
    loadTypeKategoriUnit,
    selectedCarTypeId,
} from "./index.js";

// =====================
// GLOBAL VARIABLES
// =====================
let carId;
let namaBulan;
let bulan;
let tahun;
let paramSimpan = 0;
let companyIdMain;
let companyCityMain;
let latitudeMain;
let longitudeMain;
window.selectedMobil = null;

document.addEventListener("DOMContentLoaded", () => {
    // ======================
    // DOM ELEMENTS
    // ======================
    const userId = window.Laravel.userId;
    const companyCity = window.Laravel.companyCity;
    // const userId = window.Laravel?.userId || null;
    // const companyCity = window.Laravel?.companyCity || "";
    const spinner = document.getElementById("spinnerPenjadwalan");
    const loadingText = document.getElementById("loadingTextPenjadwalan");
    const submitCariBtn = document.getElementById("submit_cari_penjadwalan");
    const formEl = document.getElementById("data_customer_form");
    const toggle = document.getElementById("autoDriverToggle");
    const toggleBulanan = document.getElementById("autoDriverToggleJadwalBulanan");
    const selectDriver = document.getElementById("nama_driver");
    const selectDriverBulanan = document.getElementById("nama_driver_jadwal_bulanan");
    const platNomor = document.getElementById("platNomor");
    const tanggalBerangkat = document.getElementById("tanggalBerangkat");
    const tanggalPulang = document.getElementById("tanggalPulang");
    const submitJadwalBtn = document.getElementById("submit_jadwal");
    // attachSubmitHandler();
    const bulanMap = {
        Jan: 1,
        Feb: 2,
        Mar: 3,
        Apr: 4,
        Mei: 5,
        Jun: 6,
        Jul: 7,
        Agu: 8,
        Sep: 9,
        Okt: 10,
        Nov: 11,
        Des: 12,
    };

    spinner?.classList.add("hidden");
    loadingText?.classList.add("hidden");

    // ======================
    // INIT FUNCTIONS
    // ======================
    // attachSubmitHandler();
    initReschedule();
    initTanggalSingleAja("#tanggalBerangkat");
    initTanggalSingleAja("#tanggalPulang");
    initTanggalSingleEnd("#tanggal_sampai");
    initTanggalSingleEnd("#tanggal_sampai_lepas");

    // ======================
    // DRIVER TOGGLE
    // ======================
    toggle?.addEventListener("change", () => {
        if (toggle.checked) {
            selectDriver.disabled = true;
            selectDriver.classList.add("bg-gray-200", "cursor-not-allowed");
        } else {
            selectDriver.disabled = false;
            selectDriver.classList.remove("bg-gray-200", "cursor-not-allowed");
        }
    });

    toggleBulanan?.addEventListener("change", () => {
        if (toggleBulanan.checked) {
            selectDriverBulanan.disabled = true;
            selectDriverBulanan.classList.add(
                "bg-gray-200",
                "cursor-not-allowed",
            );
        } else {
            selectDriverBulanan.disabled = false;
            selectDriverBulanan.classList.remove(
                "bg-gray-200",
                "cursor-not-allowed",
            );
        }
    });

    // ======================
    // LOAD INITIAL DATA
    // ======================
    setTimeout(() => {
        loadData(window.company_id);
        const mapContainer = document.getElementById("mapPenjadwalan");
        if (mapContainer && mapContainer._leaflet_id) map.invalidateSize();
    }, 300);

    let currentCoords = {
        latAsal: null,
        lonAsal: null,
        latTujuan: null,
        lonTujuan: null,
    };
    document.addEventListener("penjadwalanCoordsUpdated", (e) => {
        currentCoords = { ...e.detail };
    });

    // ======================
    // SUBMIT PENJADWALAN
    // ======================
    submitJadwalBtn.addEventListener("click", async (e) => {
        e.preventDefault();
        if (submitJadwalBtn.disabled) return;
        submitJadwalBtn.disabled = true;
        const jadwalType = document.getElementById("jadwalSelectedType")?.value;
        const chkDalamKotaPlus = document.getElementById("chkDalamKotaPenjadwalan");

        let data = null;
        let endpoint = null;
        let driver = 0;
        let asalX, tujuanX, latX, lonX, latTujuanX, lonTujuanX;

        if (chkDalamKotaPlus.checked) {
            asalX = window.companyCity;
            tujuanX = window.companyCity;
            latX = parseFloat(window.COMPANY_LATITUDE);
            lonX = parseFloat(window.COMPANY_LONGITUDE);
            latTujuanX = latX;
            lonTujuanX = lonX;

            if (paramSimpan === 1) {
                asalX = companyCityMain;
                tujuanX = companyCityMain;
                latX = parseFloat(latitudeMain);
                lonX = parseFloat(longitudeMain);
                latTujuanX = latX;
                lonTujuanX = lonX;
            }
        } else {
            asalX = document.getElementById("kotaAsalPenjadwalan")?.value || "-";
            tujuanX = document.getElementById("kotaTujuanPenjadwalan")?.value || "-";

            latX = currentCoords.latAsal;
            lonX = currentCoords.lonAsal;
            latTujuanX = currentCoords.latTujuan;
            lonTujuanX = currentCoords.lonTujuan;

            if (paramSimpan === 1) {
                asalX = companyCityMain;
                latX = parseFloat(latitudeMain);
                lonX = parseFloat(longitudeMain);
            }
        }

        // ====================== JADWAL PLUS ======================
        if (jadwalType === "plus") {
            if (!toggle.checked) {
                const val = selectDriver.value;
                if (!val) {
                    return Swal.fire({
                        icon: "warning",
                        title: "Oops...",
                        text: "Pilih driver terlebih dahulu!",
                    });
                }
                driver = val;
            }

            endpoint = "/penjadwalan/store";
            data = {
                schedule_code: "SCH-" + Date.now(),
                user_id: userId,
                tanggal: document.getElementById("modalDateJadwal").innerText,
                id_car_type: selectedCarTypeId,
                harga: window.currentSubtotal,
                ppn: window.currentPPN,
                grand_total: window.currentGrandTotal,
                asal: asalX,
                tujuan: tujuanX,
                driver_id: driver,
                jam: document.getElementById("jam").value,
                alamat_jemput: document.getElementById("alamat").value,
                margin: document.getElementById("margin").value,
                tanggal_sampai: document.getElementById("tanggal_sampai").value,
                customer_name: document.getElementById("nama").value,
                customer_phone: document.getElementById("telp").value,
                customer_address: document.getElementById("alamat").value,
                latAsal: latX,
                lonAsal: lonX,
                latTujuan: latTujuanX,
                lonTujuan: lonTujuanX,
                paramSimpan: paramSimpan,
                companyIdMain: companyIdMain,
            };
        }

        // ====================== JADWAL BULANAN ======================
        else if (jadwalType === "bulanan") {
            endpoint = "/penjadwalan/storeBulanan";

            // 1. Ambil Element UI
            const toggleBulanan = document.getElementById("autoDriverToggleJadwalBulanan");
            const selectDriverBulanan = document.getElementById("nama_driver_jadwal_bulanan");
            const modalDateElement = document.getElementById("modalDateJadwalBulanan");
            const lamaSewaInput = document.getElementById("lamaSewaJadwalBulanan");
            const hargaInput = document.getElementById("harga_jadwal_bulanan");
            const uploadPO = document.getElementById("uploadPO");
            const selectedPayment = document.getElementById("selected_payment_method_id");
            let paymentMethodId = selectedPayment ? selectedPayment.value : null;
            let nominalDP = 0;

            // 2. Validasi Driver
            if (!toggleBulanan.checked) {
                const val = selectDriverBulanan.value;
                if (!val) {
                    return Swal.fire({
                        icon: "warning",
                        title: "Oops...",
                        text: "Pilih driver terlebih dahulu!",
                    });
                }
                driver = val;
            }

            // 3. Kalkulasi Tanggal & Lama Sewa
            const tanggal = modalDateElement ? modalDateElement.innerText.trim() : "";
            const lamaSewaBulanan = parseInt(lamaSewaInput.value) || 1;

            let tanggalSampai = "";
            if (tanggal) {
                const date = new Date(tanggal);
                date.setMonth(date.getMonth() + lamaSewaBulanan);
                tanggalSampai = date.toISOString().split("T")[0];
            }

            // 4. Validasi Penanggung Jawab
            const selectedResp = document.querySelector('input[name="resp"]:checked');
            if (!selectedResp) {
                return Swal.fire({
                    icon: "warning",
                    title: "Oops...",
                    text: "Pilih penanggung jawab terlebih dahulu!",
                });
            }
            const penanggungJawabId = selectedResp.value;

            // 5. Penentuan Asal & Koordinat (Berdasarkan paramSimpan)
            if (paramSimpan === 1) {
                asalX = typeof companyCityMain !== 'undefined' ? companyCityMain : window.companyCity;
                latX  = parseFloat(latitudeMain) || 0;
                lonX  = parseFloat(longitudeMain) || 0;
            } else {
                asalX = window.companyCity;
                latX  = parseFloat(window.COMPANY_LATITUDE) || 0;
                lonX  = parseFloat(window.COMPANY_LONGITUDE) || 0;
            }

            // Tujuan & Koordinat Tujuan
            tujuanX = document.getElementById("kotaTujuanPenjadwalanBulanan")?.value || "-";
            latTujuanX = (typeof currentCoords !== 'undefined' && currentCoords.latTujuan) ? currentCoords.latTujuan : latX;
            lonTujuanX = (typeof currentCoords !== 'undefined' && currentCoords.lonTujuan) ? currentCoords.lonTujuan : lonX;

            if (paymentMethodId == 3) {
                const inputDP = document.getElementById(`input-dp-3`);
                if (inputDP) {
                    nominalDP = inputDP.value.replace(/[^\d]/g, "") || 0;

                    if (!nominalDP || nominalDP == 0) {
                        return Swal.fire({
                            icon: "warning",
                            title: "Oops...",
                            text: "Harap masukkan nominal Down Payment (DP)!",
                        });
                    }
                }
            }

            data = {
                schedule_code: "SCH-" + Date.now(),
                user_id: userId,
                tanggal: tanggal,
                tanggal_sampai: tanggalSampai,
                lamaSewaBulanan: lamaSewaBulanan,
                id_car_type: selectedCarTypeId,
                driver_id: driver,
                asal: asalX,
                tujuan: tujuanX,
                harga: hargaInput.value.replace(/[^\d]/g, ""),
                ppn: document
                    .getElementById("ppn_jadwal_bulanan")
                    ?.value.replace(/[^\d]/g, ""),
                grand_total: document
                    .getElementById("grand_total_jadwal_bulanan")
                    ?.value.replace(/[^\d]/g, ""),
                margin: document.getElementById("marginJadwalBulanan")?.value || 0,
                alamat_jemput: document.getElementById("alamatJadwalBulanan")?.value || "-",
                customer_name: document.getElementById("namaJadwalBulanan")?.value || "-",
                customer_phone: document.getElementById("telpJadwalBulanan")?.value || "-",
                customer_address: document.getElementById("alamatJadwalBulanan")?.value || "-",
                latAsal: latX,
                lonAsal: lonX,
                latTujuan: latTujuanX,
                lonTujuan: lonTujuanX,
                paramSimpan: paramSimpan,
                companyIdMain: companyIdMain,
                penanggungJawabId: penanggungJawabId,
                payment_method_id: paymentMethodId,
                nominal_dp: nominalDP,
            };
        }

        // ====================== JADWAL LEPAS ======================
        else if (jadwalType === "lepas") {
            endpoint = "/penjadwalan/storeLepas";
            if (paramSimpan === 1) {
                asalX = typeof companyCityMain !== 'undefined' ? companyCityMain : window.companyCity;
                latX  = parseFloat(latitudeMain) || 0;
                lonX  = parseFloat(longitudeMain) || 0;
            } else {
                asalX = window.companyCity;
                latX  = parseFloat(window.COMPANY_LATITUDE) || 0;
                lonX  = parseFloat(window.COMPANY_LONGITUDE) || 0;
            }

            tujuanX = document.getElementById("tujuanJadwalLepas")?.value || asalX;
            latTujuanX = (typeof currentCoords !== 'undefined' && currentCoords.latTujuan) ? currentCoords.latTujuan : latX;
            lonTujuanX = (typeof currentCoords !== 'undefined' && currentCoords.lonTujuan) ? currentCoords.lonTujuan : lonX;

            data = {
                schedule_code: "SCH-" + Date.now(),
                user_id: userId,
                tanggal: document.getElementById("modalDateJadwalLepas").textContent.trim(),
                tanggal_sampai: document.getElementById("tanggal_sampai_lepas").value,
                id_car_type: selectedCarTypeId,
                asal: asalX,
                tujuan: tujuanX,
                alamat_jemput: document.getElementById("alamatJadwalLepas").value,
                harga: document.getElementById("harga_jadwal_lepas").value.replace(/[^\d]/g, ""),
                ppn: document
                    .getElementById("ppn_jadwal_lepas")
                    ?.value.replace(/[^\d]/g, ""),

                grand_total: document
                    .getElementById("grand_total_jadwal_lepas")
                    ?.value.replace(/[^\d]/g, ""),
                margin: document.getElementById("marginJadwalLepas").value || 0,
                customer_name: document.getElementById("namaJadwalLepas").value,
                customer_phone: document.getElementById("telpJadwalLepas").value,
                customer_address: document.getElementById("alamatJadwalLepas").value,
                latAsal: latX,
                lonAsal: lonX,
                latTujuan: latTujuanX,
                lonTujuan: lonTujuanX,
                paramSimpan: paramSimpan,
                companyIdMain: companyIdMain,
            };
        }

        // ====================== LOADING ======================
        submitJadwalBtn.disabled = true;
        Swal.fire({
            title: 'Memproses Data',
            html: `
                <div class="flex flex-col items-center py-4">
                    <div class="relative w-16 h-16 mb-4">
                        <div class="absolute inset-0 border-4 border-slate-700 rounded-full"></div>
                        <div class="absolute inset-0 border-4 border-indigo-500 rounded-full border-t-transparent animate-spin"></div>
                    </div>

                    <p class="text-[13px] text-slate-400 font-medium tracking-wide">
                        Mohon tunggu sebentar, sedang menyinkronkan jadwal...
                    </p>
                </div>
            `,
            background: '#1e293b',
            color: '#ffffff',
            showConfirmButton: false,
            allowOutsideClick: false,
            customClass: {
                popup: 'rounded-3xl border border-slate-700 shadow-2xl',
                title: 'text-xl font-bold tracking-tight pt-6'
            },
            didOpen: () => {
                Swal.hideLoading();
            }
        });

        // ====================== SUBMIT BULANAN (FORMDATA) ======================
        if (jadwalType === "bulanan") {
            try {
                const formData = new FormData();
                Object.keys(data).forEach((key) => {
                    formData.append(key, data[key]);
                });

                const poFile = document.getElementById("uploadPO")?.files[0];
                if (poFile) formData.append("po_file", poFile);

                const res = await fetch(endpoint, {
                    method: "POST",
                    headers: {
                        "X-CSRF-TOKEN": document
                            .querySelector('meta[name="csrf-token"]')
                            .getAttribute("content"),
                    },
                    body: formData,
                });

                const json = await res.json();
                if (!res.ok) throw new Error(json.message || "Gagal menyimpan");

                Swal.fire({
                    icon: "success",
                    title: "Sukses",
                    text: "Jadwal bulanan berhasil disimpan",
                    timer: 2000,
                    showConfirmButton: false,
                });
                refreshJadwalBulanAktif();
                formEl.reset();

                const modal = document.getElementById("modalJadwal");
                modal?.classList.add("hidden");
                document.body.classList.remove("overflow-hidden");

                const content = modal?.querySelector("#modalContentJadwal");
                if (content) {
                    content.classList.remove("scale-0", "opacity-0");
                    content.classList.add("scale-100", "opacity-100");
                }
            } catch (err) {
                Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text: err.message,
                });
            } finally {
                submitJadwalBtn.disabled = false;
            }
            return;
        }

        // =========================================
        // TAMBAHAN BIAYA
        // =========================================

        if (data) {

            const costPelayanan = [];

            document
                .querySelectorAll('input[name="costPelayanan[]"]:checked')
                .forEach(el => {
                    costPelayanan.push(parseInt(el.value));
                });

            const costAmount = {};

            document
                .querySelectorAll('input[name^="cost_amount"]')
                .forEach(el => {

                    const match = el.name.match(/\[(\d+)\]/);

                    if (match) {

                        costAmount[match[1]] =
                            parseInt(
                                (el.value || "0").replace(/[^\d]/g, "")
                            ) || 0;
                    }
                });

            data.costPelayanan = costPelayanan;
            data.cost_amount = costAmount;

            console.log("Biaya Tambahan:", costPelayanan);
            console.log("Nominal:", costAmount);
        }

        // ====================== SUBMIT PLUS & LEPAS (JSON) ======================
        try {
            const res = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-CSRF-TOKEN": document
                        .querySelector('meta[name="csrf-token"]')
                        .getAttribute("content"),
                },
                body: JSON.stringify(data),
            });

            const json = await res.json();
            if (!res.ok) throw new Error(json.message || "Gagal menyimpan");

            Swal.fire({
                icon: "success",
                title: "Sukses",
                text: json.message,
                timer: 2000,
                showConfirmButton: false,
            });

            refreshJadwalBulanAktif();
            resetModalJadwal();
            formEl.reset();

            const modal = document.getElementById("modalJadwal");
            modal?.classList.add("hidden");
            document.body.classList.remove("overflow-hidden");

            const content = modal?.querySelector("#modalContentJadwal");
            if (content) {
                content.classList.remove("scale-0", "opacity-0");
                content.classList.add("scale-100", "opacity-100");
            }
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Gagal",
                text: err.message,
            });
        } finally {
            submitJadwalBtn.disabled = false;
        }
    });

    // function attachSubmitHandler() {
    //     const formEl = document.getElementById("formPenjadwalan");

    //     if (submitJadwalBtn && formEl && !submitJadwalBtn.dataset.bound) {
    //         submitJadwalBtn.dataset.bound = true;
    //         submitJadwalBtn.addEventListener("click", async (e) => {
    //             e.preventDefault();
    //             await handleSubmit(formEl, submitJadwalBtn);
    //         });
    //     }
    // }

    // ======================
    // SEARCH BY PLAT NOMOR
    // ======================
    submitCariBtn?.addEventListener("click", async (event) => {
        event.preventDefault();
        try {
            const startDate = formatDate(new Date(tahun, bulan - 1, 1));
            const endDate = formatDate(new Date(tahun, bulan, 0));

            const response = await fetch(
                `/penjadwalan/get-plat-nomor-by-category-id?` +
                    `keyword=${encodeURIComponent(platNomor.value)}` +
                    `&carId=${encodeURIComponent(carId)}` +
                    `&tanggalBerangkat=${encodeURIComponent(startDate)}` +
                    `&tanggalPulang=${encodeURIComponent(endDate)}`,
            );
            const data = await response.json();

            toggleTanggalContainer(bulan);

            const jadwalEksisting = Array.isArray(data)
                ? data.map((item) => ({
                      car_id: item.car_type_id ?? 0,
                      tanggal: item.tanggal ?? item.delivery_date ?? "-",
                      type_name: item.type_name ?? "",
                      plate_number: item.plat_nomor ?? "",
                      transmission:
                          item.transmission === "Manual"
                              ? "MT"
                              : item.transmission === "Automatic"
                                ? "AT"
                                : (item.transmission ?? ""),
                      year: item.year ?? "",
                      jadwal_id: item.jadwal_id ?? 0,
                      schedule_code: item.schedule_code ?? "-",
                      harga:
                          item.harga ??
                          item.harga_bulanan ??
                          item.harga_lepas_kunci ??
                          0,
                      tujuan: item.tujuan ?? "-",
                      jam: item.jam ?? "-",
                      alamat_jemput: item.alamat_jemput ?? "-",
                      delivery_date: item.delivery_date ?? "-",
                      selisih_hari: item.selisih_hari ?? 0,
                      is_color: item.is_color ?? 0,
                      last_count: item.last_count ?? 0,
                  }))
                : [];

            tampilkanTanggalRange(startDate, endDate, jadwalEksisting);
        } catch (error) {
            console.error("Error saat mencari:", error);
        }
    });

    // ======================
    // PILIH BULAN
    // ======================

    let currentScheduleController = null; //tambahan baru1

    if (!window.__bulanListenerInitialized) {
        window.__bulanListenerInitialized = true;

        document.addEventListener("click", async (e) => {
            const item = e.target.closest(".bulan-item");
            if (!item || item.classList.contains("cursor-not-allowed")) return;

            const carId = window.selectedMobil?.id;
            if (!carId) {
                return Swal.fire({
                    title: 'Mobil Belum Dipilih',
                    html: `
                        <div class="flex flex-col items-center py-2">
                            <div class="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-4">
                                <i class="fa-solid fa-car-side text-red-500 text-2xl animate-bounce"></i>
                            </div>
                            <p class="text-[13px] text-slate-300">
                                Silakan pilih unit mobil terlebih dahulu untuk memuat jadwal kalender yang tersedia.
                            </p>
                        </div>
                    `,
                    background: '#1e293b',
                    color: '#ffffff',
                    showConfirmButton: true,
                    confirmButtonText: 'Pilih Mobil Sekarang',
                    confirmButtonColor: '#4f46e5',
                    customClass: {
                        popup: 'rounded-[2rem] border border-slate-700 shadow-2xl',
                        title: 'text-xl font-black pt-4',
                        confirmButton: 'rounded-xl px-8 py-3 text-sm font-bold uppercase tracking-wider'
                    }
                });
            }

            // Persiapan Data
            const namaBulan = item.dataset.bulan;
            const bulan = bulanMap[namaBulan];
            const tahun = new Date().getFullYear();
            const startDate = formatDate(new Date(tahun, bulan - 1, 1));
            const endDate = formatDate(new Date(tahun, bulan, 0));
            const companyId = window.company_id;

            // UI Active State
            document.querySelectorAll(".bulan-item").forEach((el) => el.classList.remove("bg-indigo-600", "text-white"));
            item.classList.add("bg-indigo-600", "text-white");
            toggleTanggalContainer("bulan");

            // Tampilkan Loading Premium
            Swal.close();

            Swal.fire({
                title: 'Memuat Jadwal',
                html: `
                    <div class="flex flex-col items-center py-3">
                        <div class="relative w-12 h-12 mb-4">
                            <div class="absolute inset-0 border-4 border-slate-700 rounded-full"></div>
                            <div class="absolute inset-0 border-4 border-indigo-500 rounded-full border-t-transparent animate-spin"></div>
                        </div>
                        <p class="text-[13px] text-slate-300 font-medium tracking-wide">Menyingkronkan jadwal armada...</p>
                    </div>
                `,
                background: '#1e293b',
                color: '#ffffff',
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => { Swal.hideLoading(null); }
            });

            try {

                // Batalkan request sebelumnya jika masih berjalan (tamabahan baru2)
                if (currentScheduleController) {
                    currentScheduleController.abort();
                }

                // Buat controller baru (tamabahan baru3)
                currentScheduleController = new AbortController();

                const signal = currentScheduleController.signal;

                // Eksekusi kedua fetch secara bersamaan
                const [resJadwal, resSharing] = await Promise.all([
                    // fetch(`/penjadwalan/get-jadwal-by-user-id-and-car-id?company_id=${companyId}&car_id=${carId}&tanggal_awal=${startDate}&tanggal_akhir=${endDate}`).then(r => r.json()),
                    fetch(
                        `/penjadwalan/get-jadwal-by-user-id-and-car-id?company_id=${companyId}&car_id=${carId}&tanggal_awal=${startDate}&tanggal_akhir=${endDate}`,
                        { signal }
                    ).then(r => r.json()),

                    // fetch(`/penjadwalan/get-sharing-schedule-by-company-contract?tanggal_awal=${startDate}&tanggal_akhir=${endDate}`).then(r => r.json())
                    fetch(
                        `/penjadwalan/get-sharing-schedule-by-company-contract?tanggal_awal=${startDate}&tanggal_akhir=${endDate}`,
                        { signal }
                    ).then(r => r.json())

                ]);

                // 1. Handle Jadwal Eksisting
                const jadwalEksisting = (resJadwal.data || []).map(item => ({
                    car_id: item.car_type_id,
                    tanggal: item.tanggal,
                    type_name: item.type_name,
                    plate_number: item.plat_nomor,
                    transmission: item.transmission === "Manual" ? "MT" : (item.transmission === "Automatic" ? "AT" : item.transmission),
                    year: item.year,
                    jadwal_id: item.jadwal_id,
                    schedule_code: item.schedule_code,
                    harga: item.harga,
                    tujuan: item.tujuan,
                    jam: item.jam,
                    alamat_jemput: item.alamat_jemput,
                    delivery_date: item.delivery_date,
                    selisih_hari: item.selisih_hari,
                    is_color: item.is_color,
                    last_count: item.last_count,
                }));
                tampilkanTanggalRange(startDate, endDate, jadwalEksisting);

                // 2. Handle Sharing Schedule
                const sharingSchedules = (resSharing.data || []).map(item => ({
                    company_main_id: item.company_main_id || null,
                    company_main_city: item.company_main_city || null,
                    company_main_name: item.company_main_name || null,
                    car_id: item.car_type_id || null,
                    tanggal: item.tanggal || null,
                    type_name: item.type_name || "",
                    plate_number: item.plat_nomor || "",
                    transmission: item.transmission === "Manual" ? "MT" : (item.transmission === "Automatic" ? "AT" : item.transmission || ""),
                    year: item.year || "",
                    jadwal_id: item.jadwal_id || null,
                    schedule_code: item.sharing_code || "",
                    harga: item.harga || 0,
                    tujuan: item.tujuan || "",
                    jam: item.jam || "",
                    alamat_jemput: item.alamat_jemput || "",
                    delivery_date: item.delivery_date || "",
                    selisih_hari: item.selisih_hari || 0,
                    latitude: item.company_contract_latitude || 0,
                    longitude: item.company_contract_longitude || 0,
                    is_color: item.is_color || "",
                    last_count: item.last_count || 0,
                }));
                tampilkanTanggalRangeCustomSharingSchedule(startDate, endDate, sharingSchedules);

                // Tutup Swal HANYA setelah render selesai
                setTimeout(() => {
                    Swal.close();
                }, 300);

            } catch (err) {

                    // Request lama dibatalkan
                    if (err.name === "AbortError") {
                        console.log("Request sebelumnya dibatalkan");
                        return;
                    }

                    console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Gagal Memuat Data',
                    text: 'Terjadi kesalahan koneksi, silakan coba lagi.',
                    background: '#1e293b',
                    color: '#ffffff'
                });
            }
        });
    }

    // ======================
    // KATEGORI UNIT CHANGE
    // ======================
    document
        .getElementById("kategoriUnitPenjadwalan")
        ?.addEventListener("change", function () {
            if (this.value) loadTypeKategoriUnit(this.value);
        });
});

function loadData(cityName = null) {
    const city = cityName || window.companyCity || "";
    const rawTanggal = document.getElementById("tanggalRangePenjadwalan")?.value || "";
    const tanggal = rawTanggal ? formatTanggalRange(rawTanggal) : "-";
    const container = document.getElementById("gridContainerPenjadwalan");
    const spinner = document.getElementById("spinnerPenjadwalan");
    const loadingText = document.getElementById("loadingTextPenjadwalan");
    ambilDataMobil(container, spinner, loadingText, city, tanggal);
}

// ======================
// SEARCH MOBIL
// ======================
document.getElementById("searchMobilBtnPenjadwalan")?.addEventListener("click", () => {
    loadData(window.company_id);
});

// ======================
// PILIH MOBIL
// ======================
window.selectMobil = function (el) {
    // Reset semua item
    document.querySelectorAll(".mobil-item").forEach((item) => {
        item.classList.remove(
            "ring-2",
            "ring-purple-500",
            "scale-105",
            "border-b-4",
            "border-purple-500",
        );
    });

    // Tandai item aktif
    el.classList.add("scale-105", "border-b-4", "border-purple-500");

    // Set GLOBAL selected mobil
    window.selectedMobil = {
        id: el.dataset.id || null,
        image: el.querySelector("img")?.getAttribute("src") ?? "/images/no-image.png",
        name: el.querySelector("p")?.textContent?.trim() ?? "-",
        city: window.companyCity ?? "-",
        transmission:el.querySelector(".transmissionMobil")?.textContent?.trim() ?? "-",
        plat: el.querySelector(".platMobil")?.textContent?.trim() ?? "-",
        tahun: el.querySelector(".tahunMobil")?.textContent?.trim() ?? "-",
    };
};

function tampilkanTanggalRange(startDateStr, endDateStr, jadwalEksisting = []) {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const container = document.getElementById("tanggalContainer");
    const grid = document.getElementById("tanggalGrid");

    endDate.setDate(endDate.getDate() + 1);
    grid.innerHTML = "";
    const grouped = {};
    jadwalEksisting.forEach((item) => {
        const plat = item.plate_number || "Tidak Diketahui";
        if (!grouped[plat]) grouped[plat] = [];
        grouped[plat].push({ ...item });
    });

    const allDates = [];
    for (
        let d = new Date(startDate);
        d <= endDate;
        d.setDate(d.getDate() + 1)
    ) {
        allDates.push(new Date(d));
    }

    const wrapper = document.createElement("div");
    wrapper.className = "flex flex-col";

    Object.entries(grouped).forEach(([plate, tanggalArray]) => {
        const rowDiv = document.createElement("div");
        rowDiv.className = "flex gap-1 items-center relative";

        const firstData = grouped[plate][0] || {};
        const labelDiv = document.createElement("div");

        labelDiv.className = `
            min-w-[80px] max-w-[120px] text-xs sm:text-sm font-semibold text-gray-700
            sticky left-0 bg-white z-10 border-r border-gray-200 plat-label
            whitespace-nowrap`;

        labelDiv.innerHTML = `
            <div class="text-[10px] font-medium text-blue-700 leading-snug tracking-tight flex items-center gap-1 overflow-hidden text-ellipsis whitespace-nowrap max-w-[100px]">
                <i class="fas fa-car-side"></i> ${firstData.type_name || "-"}
            </div>
            <div class="text-[9px] text-green-600 italic flex items-center gap-1">
                <i class="fas fa-cogs"></i> ${
                    firstData.transmission + " - " + firstData.year || "-"
                }
            </div>
            <div class="text-[9px] font-bold text-gray-900">${plate}</div>
        `;

        // const tanggalWrapper = document.createElement("div");
        // tanggalWrapper.className = `
        //     flex items-start gap-[2px] w-max
        //     overflow-x-auto px-1 pb-2 scroll-smooth
        //     custom-scrollbar
        // `;

        const tanggalWrapper = document.createElement("div");
        tanggalWrapper.className = `
            flex items-start gap-[2px] w-max
            px-1 pb-2
        `;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        allDates.forEach((dateObj) => {
            const tahun = dateObj.getFullYear();
            const bulan = dateObj.getMonth() + 1;
            const tanggal = dateObj.getDate();
            const tanggalStr = `${tahun}-${String(bulan).padStart(
                2,
                "0",
            )}-${String(tanggal).padStart(2, "0")}`;
            const hari = dateObj.toLocaleDateString("id-ID", {
                weekday: "long",
            });
            const isMinggu = hari === "Minggu";
            const isLampau = dateObj < today;

            // Cari data dari tanggalArray yang cocok
            const item = tanggalArray.find(
                (item) => item.tanggal === tanggalStr,
            );
            const isTerpakai = !!item;

            const sekarang = new Date();
            const tampilkanJam =
                item &&
                tanggalStr === sekarang.toISOString().slice(0, 10) &&
                sekarang.getHours() < 23;

            const div = document.createElement("div");
            const disabledClass = isLampau
                ? "opacity-80 cursor-pointer"
                : "cursor-pointer";
            const semuaDeliveryPadaTanggalIni = tanggalArray.flatMap((i) => {
                const hasil = [];
                const orderDate = new Date(
                    i.order_date || i.tanggal + " 00:01:00",
                );
                const deliveryDate = new Date(i.delivery_date);
                const currentDate = new Date(tanggalStr);
                if (currentDate >= orderDate && currentDate <= deliveryDate) {
                    hasil.push({
                        jadwal_id: i.jadwal_id,
                        order_date:
                            orderDate.toISOString().split("T")[0] +
                            " " +
                            (i.jam || "00:01:00"),
                        delivery_date:
                            deliveryDate.toISOString().split("T")[0] +
                            " 24:00:01",
                        selisih_hari: i.selisih_hari,
                        is_color: i.is_color,
                        last_count: i.last_count,
                    });
                }

                if (
                    Number(i.selisih_hari) === 1 &&
                    i.delivery_date.startsWith(tanggalStr)
                ) {
                    hasil.push({
                        jadwal_id: i.jadwal_id,
                        order_date: i.delivery_date.split(" ")[0] + " 00:00:01",
                        delivery_date: i.delivery_date,
                        selisih_hari: i.selisih_hari,
                        is_color: i.is_color,
                        last_count: i.last_count,
                    });
                }

                return hasil;
            });

            const warnaSegment = getSegmentWarna(semuaDeliveryPadaTanggalIni);
            const semuaJadwalId = semuaDeliveryPadaTanggalIni
                .map((i) => i.jadwal_id)
                .join(",");
            const lastCount = semuaDeliveryPadaTanggalIni
                .map((i) => i.last_count)
                .join(",");

            div.innerHTML = `
                <div class="tanggal-item relative w-[40px] h-[40px]
                    text-center border border-gray-300 rounded-md
                    overflow-hidden ${disabledClass}"
                    data-id="${semuaJadwalId.split(",")[0] || ""}"
                    data-tanggal="${tanggalStr}"
                    data-lastCount="${lastCount}"
                    data-carId="${item?.car_id || firstData.car_id || ""}">

                    <div class="absolute top-0 left-0 w-1/4 h-full ${
                        warnaSegment[0]
                    }"></div>
                    <div class="absolute top-0 left-1/4 w-1/4 h-full ${
                        warnaSegment[1]
                    }"></div>
                    <div class="absolute top-0 left-2/4 w-1/4 h-full ${
                        warnaSegment[2]
                    }"></div>
                    <div class="absolute top-0 left-3/4 w-1/4 h-full ${
                        warnaSegment[3]
                    }"></div>

                    <div class="relative z-10 flex flex-col items-center justify-center
                        w-full h-full p-0.5 transition-all duration-200 transform">
                        <div class="text-xs md:text-[11px] font-semibold leading-none ${
                            isMinggu ? "text-gray-900" : "text-gray-800"
                        }">
                            ${tanggal}
                        </div>
                        <div class="text-[9px] md:text-[8px] text-gray-500 leading-none ${
                            isMinggu ? "text-gray-900" : "text-gray-800"
                        }">
                            ${hari}
                        </div>
                    </div>
                </div>
            `;

            // ✅ Tambahkan event click di sini
            const tanggalItem = div.querySelector(".tanggal-item");

            tanggalItem.addEventListener("click", async (e) => {
                const id = e.currentTarget.dataset.id;
                const tgl = e.currentTarget.dataset.tanggal;
                const lastCount = e.currentTarget.dataset.lastCount;
                const idArray = id
                    .split(",")
                    .filter((item) => item.trim() !== "");
                let htmlContent = `<div style="display: grid; grid-template-columns: 100px auto; gap: 8px; text-align: left;">`;
                idArray.forEach((id, index) => {
                    htmlContent += ``;
                });
                htmlContent += `</div>`;
                const segments =
                    e.currentTarget.querySelectorAll("div.absolute");
                const warnaSegment = Array.from(segments).map((seg) => {
                    return seg.className
                        .split(" ")
                        .find((c) => c.startsWith("bg-"));
                });
                const semuaMerah = warnaSegment.every(
                    (w) => w === "bg-red-300",
                );
                fetchDrivers(window.company_id);
                // ✅ cek slot kosong
                const slotKosong = cekSlotKosong(warnaSegment);
                const fullSlots = [
                    "00:00 - 05:59",
                    "06:00 - 11:59",
                    "12:00 - 17:59",
                    "18:00 - 23:59",
                ];

                if (slotKosong.length > 0) {
                    const isFullRange =
                        slotKosong.length === fullSlots.length &&
                        slotKosong.every((val, i) => val === fullSlots[i]);

                    if (!isFullRange && !isLampau) {
                        const { isConfirmed } = await Swal.fire({
                            title: "⏰ Slot Kosong",
                            html: `Jam yang masih kosong:<br><br>${slotKosong.join(
                                "<br>",
                            )}<br><br>Lanjutkan entri data?`,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Yes, lanjutkan",
                            cancelButtonText: "No, batal",
                        });

                        if (!isConfirmed) {
                            return;
                        }
                    }
                }

                if (semuaMerah) {
                    try {
                        const response = await axios.get(
                            `penjadwalan/get-jadwal-by-id-single`,
                            {
                                params: { id },
                            },
                        );

                        let htmlContent = "<hr>"; // pembatas
                        let orders = [];

                        // ✅ Handle 2 kemungkinan struktur response
                        if (Array.isArray(response.data)) {
                            orders = response.data;
                        } else if (
                            response.data.success &&
                            Array.isArray(response.data.data)
                        ) {
                            orders = response.data.data;
                        }

                        if (orders.length === 0) {
                            htmlContent += `
                                <div style="text-align:center; padding:12px; color:#888;">
                                    <em>🚫 Tidak ada order di tanggal ini</em>
                                </div>`;
                        } else {
                            htmlContent += `
                                <div style="
                                    display: flex;
                                    overflow-x: auto;
                                    gap: 12px;
                                    padding: 6px;
                                    max-width: 100%;
                                    scrollbar-width: thin;
                                    scrollbar-color: #ccc transparent;
                                ">
                            `;

                            htmlContent += orders
                                .map(
                                    (order) => `
                                        <div style="
                                            min-width: 260px;
                                            flex: 0 0 auto;
                                            background:#fff;
                                            border-radius:12px;
                                            padding:16px 18px;
                                            box-shadow:0 2px 6px rgba(0,0,0,0.1);
                                            transition: transform 0.3s ease, box-shadow 0.3s ease;
                                            text-align:left;
                                        "
                                        onmouseover="this.style.transform='translateY(-4px)'; this.style.boxShadow='0 6px 16px rgba(0,0,0,0.15)';"
                                        onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 6px rgba(0,0,0,0.1)';">

                                            <div style="display:flex; justify-content:space-between; align-items:center; font-size:14px; font-weight:600; color:#333; margin-bottom:6px;">
                                                <span style="font-size:13px; color:#666; text-transform:uppercase; font-weight:normal;">
                                                    ${
                                                        order.customer_name ||
                                                        "-"
                                                    }
                                                </span>
                                                <span>${
                                                    order.schedule_code ||
                                                    order.order_code
                                                }</span>
                                            </div>

                                            <div style="font-size:13px; color:#666; margin-bottom:6px;">
                                                📅 ${order.tanggal}, ${
                                                    order.jam
                                                } - ${order.delivery_date}
                                                        </div>

                                                        <div style="font-size:13px; color:#666; margin-bottom:6px;">
                                                            🚗 ${
                                                                order.kota_asal
                                                            } ➡ ${order.tujuan}
                                            </div>

                                            <div style="font-size:13px; color:#666; margin-bottom:10px;">
                                                <i class="fa-solid fa-user-tie"></i> ${
                                                    order.driver_name
                                                        ? order.driver_name
                                                        : "?"
                                                }
                                            </div>

                                            <div style="font-size:14px; font-weight:600; color:#28a745; margin-top:8px;">
                                                💰 Rp ${Number(
                                                    order.harga || 0,
                                                ).toLocaleString("id-ID")}
                                            </div>
                                        </div>
                                    `,
                                )
                                .join("");
                            htmlContent += `</div>`;
                        }

                        Swal.fire({
                            title: "📋 Daftar Order",
                            html: htmlContent,
                            width: "600px",
                            showCloseButton: true,
                            showConfirmButton: false,
                            scrollbarPadding: false,
                        });
                    } catch (error) {
                        console.error("Error ambil data:", error);
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Terjadi kesalahan saat mengambil data!",
                        });
                    }
                } else {
                    if (isLampau) {
                        Swal.fire({
                            title: "Tanggal sudah kadaluarsa",
                            icon: "info",
                            showConfirmButton: false,
                            timer: 2000,
                            timerProgressBar: true,
                            width: "28rem",
                            customClass: {
                                popup: "rounded-lg shadow-md",
                                title: "text-base font-medium whitespace-nowrap",
                            },
                        });

                        if (id) {
                            try {
                                const params = {
                                    order_date: tgl,
                                    id_type:
                                        tanggalItem.getAttribute("data-carId"),
                                };
                                const response = await axios.get(
                                    "/penjadwalan/get-jadwal-by-date",
                                    { params },
                                );

                                htmlContent += `<hr>`;

                                if (response.data.success) {
                                    const orders = response.data.data;
                                    if (orders.length === 0) {
                                        htmlContent += `
                                            <div style="text-align:center; padding:12px; color:#888;">
                                                <em>🚫 Tidak ada order di tanggal ini</em>
                                            </div>`;
                                    } else {
                                        htmlContent += `
                                            <div style="
                                                max-height: 60vh;
                                                overflow-y: auto;
                                                padding-right:6px;
                                                scrollbar-width: thin;
                                                scrollbar-color: #ccc transparent;
                                            ">
                                        `;

                                        orders.forEach((order) => {
                                            htmlContent += `
                                                <div style="
                                                    background:#f8f9fa;
                                                    border-radius:8px;
                                                    padding:10px 12px;
                                                    margin-bottom:8px;
                                                    box-shadow:0 1px 3px rgba(0,0,0,0.08);
                                                    transition: all 0.3s ease;
                                                "
                                                onmouseover="this.style.transform='scale(1.02)'; this.style.boxShadow='0 4px 12px rgba(0,0,0,0.15)';"
                                                onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)';">
                                                    <div style="font-weight:600; color:#333;">${
                                                        order.order_code
                                                    } - ${
                                                        order.customer_name
                                                    }</div>
                                                    <div style="font-size:13px; color:#666;">📅 ${
                                                        order.order_date +
                                                        " - " +
                                                        order.delivery_date
                                                    }</div>
                                                    <div style="font-size:13px; color:#666;">🚗 ${
                                                        order.kota_asal
                                                    } ➡ ${
                                                        order.kota_tujuan
                                                    }</div>
                                                    <div style="font-size:13px; color:#666;">💰 Rp ${Number(
                                                        order.harga,
                                                    ).toLocaleString(
                                                        "id-ID",
                                                    )}</div>
                                                </div>
                                            `;
                                        });

                                        htmlContent += `</div>`;
                                    }
                                } else {
                                    htmlContent += `<div style="color:#b00; text-align:center;">${response.data.message}</div>`;
                                }
                            } catch (error) {
                                console.error(error);
                                htmlContent += `<div><em>Terjadi kesalahan saat memuat data</em></div>`;
                            }

                            Swal.fire({
                                title: "Detail Jadwal",
                                html: htmlContent,
                                width: "40rem",
                                showCloseButton: true,
                                showConfirmButton: false,
                                customClass: {
                                    popup: "swal2-rounded",
                                },
                            });
                        } else {
                            if (
                                window.divisionId !== 1 &&
                                window.divisionId !== 11
                            ) {
                                Swal.fire({
                                    title: "Tanggal sudah kadaluarsa",
                                    icon: "info",
                                    showConfirmButton: false,
                                    timer: 2000,
                                    timerProgressBar: true,
                                    width: "28rem",
                                    customClass: {
                                        popup: "rounded-lg shadow-md",
                                        title: "text-base font-medium whitespace-nowrap",
                                    },
                                });
                            }
                        }
                    } else {
                        const backupData = tanggalArray[0] || {};
                        const mobilData = item || backupData;

                        const dynamicMobil = {
                            id: mobilData.car_id || null,
                            name: mobilData.type_name || "-",
                            transmission: mobilData.transmission || "-",
                            plat: mobilData.plate_number || "-",
                            year: mobilData.year || "-",
                        };

                        paramSimpan = 0;
                        showModalPenjadwalan(
                            "modalJadwal",
                            id,
                            lastCount,
                            tgl,
                            item || {},
                            selectedMobil,
                            dynamicMobil,
                            companyCity,
                            "NULL",
                            "NULL",
                            companyIdMain,
                            paramSimpan,
                        );
                    }
                }
            });

            div.querySelector(".tanggal-item").addEventListener("click", () => {
                tanggalWrapper
                    .querySelectorAll(".tanggal-item")
                    .forEach((el) => {
                        el.classList.remove(
                            "border-b-4",
                            "border-indigo-500",
                            "ring-indigo-300",
                        );
                        el.classList.add("border-gray-300");
                    });
                div.querySelector(".tanggal-item").classList.remove(
                    "border-gray-300",
                );
                div.querySelector(".tanggal-item").classList.add(
                    "border-b-4",
                    "border-indigo-500",
                    "ring-indigo-300",
                );
            });

            tanggalWrapper.appendChild(div);
        });

        rowDiv.appendChild(labelDiv);
        rowDiv.appendChild(tanggalWrapper);
        grid.appendChild(rowDiv);
    });

    grid.appendChild(wrapper);
    toggleTanggalContainer("range");
}

function toggleTanggalContainer(mode) {
    const containerBulan = document.getElementById("tanggalContainer");
    const wrapperBulan = document.getElementById("tanggalWrapper");
    containerBulan?.classList.remove("hidden");
    wrapperBulan?.classList.remove("hidden");
}

function getSegmentWarna(datetime) {
    const warna = ["bg-white", "bg-white", "bg-white", "bg-white"];
    if (!datetime) return warna;

    let waktuList = [];

    if (
        Array.isArray(datetime) &&
        typeof datetime[0] === "object" &&
        datetime[0] !== null
    ) {
        const adaMerah = datetime.some((item) => Number(item.is_color) === 1);
        if (adaMerah) {
            return ["bg-red-300", "bg-red-300", "bg-red-300", "bg-red-300"];
        }

        waktuList = datetime.filter(
            (item) =>
                typeof item.order_date === "string" &&
                item.order_date.includes(" "),
        );
    } else if (Array.isArray(datetime)) {
        waktuList = datetime
            .filter((item) => typeof item === "string" && item.includes(" "))
            .map((str) => ({ order_date: str, selisih_hari: 0 }));
    } else if (typeof datetime === "string") {
        waktuList = parseDatetimeList(datetime)
            .filter((item) => item.includes(" "))
            .map((str) => ({ order_date: str, selisih_hari: 0 }));
    } else {
        return warna;
    }

    waktuList.forEach((item) => {
        const {
            order_date: orderDate,
            delivery_date: deliveryDate,
            is_color,
            selisih_hari,
            last_count,
        } = item;

        const spaceIndex = orderDate.indexOf(" ");
        if (spaceIndex === -1) return;

        const jamStr = orderDate.substring(spaceIndex + 1);
        const colonIndex = jamStr.indexOf(":");
        const jamOnly =
            colonIndex !== -1 ? jamStr.substring(0, colonIndex) : jamStr;
        const jamInt = parseInt(jamOnly);
        if (isNaN(jamInt)) return;
        const spaceIndexDelivery = deliveryDate?.indexOf(" ") ?? -1;
        if (spaceIndexDelivery === -1) return;
        const jamDeliveryStr = deliveryDate.substring(spaceIndexDelivery + 1);
        const colonIndexDelivery = jamDeliveryStr.indexOf(":");
        const jamDeliveryOnly =
            colonIndexDelivery !== -1
                ? jamDeliveryStr.substring(0, colonIndexDelivery)
                : jamDeliveryStr;
        const jamDeliveryInt = parseInt(jamDeliveryOnly);
        if (isNaN(jamDeliveryInt)) return;
        // Prioritas: is_color
        const preset = [
            "bg-gray-300",
            "bg-blue-300",
            "bg-yellow-300",
            "bg-purple-300",
        ];

        warna.fill("");

        if (is_color === 1) {
            warna.fill("bg-red-300");
        } else {
            const getSlot = (jam) => {
                if (jam >= 0 && jam < 6) return 0;
                if (jam >= 6 && jam < 12) return 1;
                if (jam >= 12 && jam < 18) return 2;
                if (jam >= 18 && jam <= 24) return 3;
                return -1;
            };

            if (last_count > 0) {
                const slot = getSlot(jamDeliveryInt);
                for (let i = 0; i <= slot; i++) {
                    warna[i] = preset[i];
                }
            } else {
                const start = getSlot(jamInt);
                const end = getSlot(jamDeliveryInt);
                for (let i = start; i <= end; i++) {
                    warna[i] = preset[i];
                }
            }
        }
    });

    return warna;
}

function parseDatetimeList(input) {
    const result = [];

    if (!input || typeof input !== "string") return result;

    let current = "";
    for (let i = 0; i < input.length; i++) {
        const char = input[i];
        if (char === ",") {
            if (current.trim()) result.push(current.trim());
            current = "";
        } else {
            current += char;
        }
    }
    if (current.trim()) result.push(current.trim());

    return result;
}

function ambilDataMobil(container, spinner, loadingText) {
    container.innerHTML = "";
    spinner?.classList.remove("hidden");
    loadingText?.classList.remove("hidden");

    fetch(`penjadwalan/get-car-by-company-id-jadwal`)
        .then((res) => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
        })
        .then((data) => {
            spinner?.classList.add("hidden");
            loadingText?.classList.add("hidden");

            // ⛔ Hanya ambil yang punya harga
            const filteredData = data.filter((item) => item.price !== null);

            if (filteredData.length === 0) {
                container.innerHTML = `
                    <div class="col-span-full w-full min-h-[200px] flex justify-center items-center">
                        <div class="text-center text-sm text-gray-600 animate-fade-in-up transition-all duration-500 ease-out">
                            <p class="mb-2 text-base font-medium text-blue-700">
                                Mobil tidak tersedia untuk kota ini.
                            </p>
                            <a href="https://wa.me/6281131183229" target="_blank"
                            class="inline-flex items-center gap-2 px-4 py-2 bg-green-500 text-white
                                rounded-full shadow hover:bg-green-600 hover:scale-105 transition transform
                                duration-300">
                                <i class="fab fa-whatsapp text-lg"></i> Hubungi Admin
                            </a>
                        </div>
                    </div>
                    `;
                return;
            }

            // ✅ Tampilkan mobil yang punya harga
            const itemsHTML = filteredData
                .map((item) => {
                    const image = item.category_image
                        ? `/images/${item.category_image}`
                        : "/images/no-image.png";
                    const name = item.category_name || "-";
                    const carCategoryId = item.category_id || "-";

                    return `
                        <div data-id="${carCategoryId}"
                            onclick="selectMobil(this)"
                            class="mobil-item group flex flex-col items-center justify-center cursor-pointer
                                transition-all duration-300 rounded-xl bg-transparent
                                w-20 sm:w-24 relative shadow-sm hover:shadow-lg hover:-translate-y-1
                                border border-gray-100 hover:border-indigo-300
                                px-2 py-2">

                            <!-- Wrapper gambar -->
                            <div class="w-10 h-10 sm:w-12 sm:h-12 overflow-hidden flex items-center justify-center">
                                <img src="${image}" alt="${name}"
                                    class="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110" />
                            </div>

                            <!-- Nama Mobil -->
                            <p class="mt-1 text-[7px] sm:text-[8px] text-gray-700 font-semibold text-center truncate w-full">
                                ${name}
                            </p>

                            <!-- Badge selected -->
                            <span class="selected-indicator hidden absolute -right-1 -top-1
                                bg-green-500 text-white text-[7px] font-bold rounded-full w-4 h-4
                                flex items-center justify-center shadow-md">
                                ✔
                            </span>
                        </div>
                    `;
                })
                .join("");

            container.innerHTML = itemsHTML;
        })
        .catch((err) => {
            spinner?.classList.add("hidden");
            loadingText?.classList.add("hidden");

            container.innerHTML = `
                <p class="text-red-500 col-span-3 text-center">
                    Terjadi kesalahan saat memuat data.
                </p>`;
            console.error("Gagal memuat data:", err);
        });
}

function shareWA(callbackData) {
    if (!callbackData) return;

    fetch("penjadwalan/share-wa", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": document.querySelector('input[name="_token"]')
                .value,
        },
        body: JSON.stringify({
            schedule_id: callbackData.schedule?.schedule_id,
            order_id: callbackData.schedule?.order_id,
        }),
    })
        .then((res) => res.json())
        .catch(() => Swal.fire("Error", "Terjadi kesalahan server", "error"));
}

async function refreshJadwalBulanAktif() {
    const bulanMap = {
        Jan: 1, Feb: 2, Mar: 3, Apr: 4, Mei: 5, Jun: 6,
        Jul: 7, Agu: 8, Sep: 9, Okt: 10, Nov: 11, Des: 12,
    };

    // 1. Ambil elemen bulan aktif atau default bulan sekarang
    let activeMonthEl = document.querySelector(".bulan-item.bg-indigo-600.text-white") || (() => {
        const today = new Date();
        const bulanSekarang = Object.keys(bulanMap).find(key => bulanMap[key] === today.getMonth() + 1);
        const el = document.querySelector(`.bulan-item[data-bulan="${bulanSekarang}"]`);
        if (el) el.classList.add("bg-indigo-600", "text-white");
        return el;
    })();

    if (!activeMonthEl) return console.error("❌ Tidak ada elemen bulan aktif");

    const namaBulan = activeMonthEl.dataset.bulan;
    const bulan = bulanMap[namaBulan];
    const tahun = new Date().getFullYear();

    const startDate = new Date(tahun, bulan - 1, 1);
    const endDate = new Date(tahun, bulan, 0);

    if (isNaN(startDate.getTime())) return console.error("❌ Invalid Date");

    const startDateStr = startDate.toISOString().split("T")[0];
    const endDateStr = endDate.toISOString().split("T")[0];

    toggleTanggalContainer("bulan");

    // Jika mobil belum dipilih, bersihkan UI
    if (!window.selectedMobil || !window.selectedMobil.id) {
        tampilkanTanggalRange(startDateStr, endDateStr, []);
        tampilkanTanggalRangeCustomSharingSchedule(startDateStr, endDateStr, []);
        return;
    }

    // 2. Loading State
    Swal.fire({
        title: 'Sinkronisasi Jadwal',
        html: `
            <div class="flex flex-col items-center py-3">
                <div class="relative w-12 h-12 mb-4">
                    <div class="absolute inset-0 border-4 border-slate-700 rounded-full"></div>
                    <div class="absolute inset-0 border-4 border-indigo-500 rounded-full border-t-transparent animate-spin"></div>
                </div>
                <p class="text-[13px] text-slate-300 font-medium tracking-wide">Memperbarui data...</p>
            </div>
        `,
        background: '#1e293b',
        color: '#ffffff',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => { Swal.hideLoading(); }
    });

    try {
        const carId = window.selectedMobil.id;
        const companyId = window.company_id;
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || "";

        // 3. Fetch Data Paralel
        const [resJadwal, resSharing] = await Promise.all([
            fetch(`/penjadwalan/get-jadwal-by-user-id-and-car-id?company_id=${companyId}&car_id=${carId}&tanggal_awal=${startDateStr}&tanggal_akhir=${endDateStr}`, {
                headers: { "X-CSRF-TOKEN": csrfToken }
            }).then(r => r.json()),
            fetch(`/penjadwalan/get-sharing-schedule-by-company-contract?tanggal_awal=${startDateStr}&tanggal_akhir=${endDateStr}`, {
                headers: { "X-CSRF-TOKEN": csrfToken }
            }).then(r => r.json())
        ]);

        // 4. Mapping Jadwal Eksisting
        const jadwalEksisting = (resJadwal.data || []).map(item => ({
            car_id: item.car_type_id || null,
            tanggal: item.tanggal || "",
            type_name: item.type_name || "",
            plate_number: item.plat_nomor || "",
            transmission: item.transmission === "Manual" ? "MT" : (item.transmission === "Automatic" ? "AT" : item.transmission || ""),
            year: item.year || "",
            jadwal_id: item.jadwal_id || null,
            schedule_code: item.schedule_code || "",
            harga: item.harga || 0,
            tujuan: item.tujuan || "",
            jam: item.jam || "",
            alamat_jemput: item.alamat_jemput || "",
            delivery_date: item.delivery_date || "",
            selisih_hari: item.selisih_hari || 0,
            is_color: item.is_color || false,
            last_count: item.last_count || 0,
        }));

        // 5. Mapping Sharing Schedule
        const sharingSchedules = (resSharing.data || []).map(item => {
            // Fallback Kota agar tidak Unknown
            let city = item.company_main_city;
            if (!city || city === "null" || city === "Unknown") {
                city = item.alamat_jemput ? item.alamat_jemput.split(',')[0].trim() : "Surabaya";
            }

            return {
                company_main_id: item.company_main_id || null,
                company_main_city: city,
                company_main_name: item.company_main_name || "Mitra WisataJatim",
                car_id: item.car_type_id || null,
                tanggal: item.tanggal || null,
                type_name: item.type_name || "",
                plate_number: item.plat_nomor || "",
                transmission: item.transmission === "Manual" ? "MT" : (item.transmission === "Automatic" ? "AT" : item.transmission || ""),
                year: item.year || "",
                jadwal_id: item.jadwal_id || null,
                schedule_code: item.sharing_code || "",
                harga: item.harga || 0,
                tujuan: item.tujuan || "",
                jam: item.jam || "",
                alamat_jemput: item.alamat_jemput || "",
                delivery_date: item.delivery_date || "",
                selisih_hari: item.selisih_hari || 0,
                latitude: item.company_contract_latitude || 0,
                longitude: item.company_contract_longitude || 0,
                is_color: item.is_color || "",
                last_count: item.last_count || 0,
            };
        });

        // 6. Render UI
        tampilkanTanggalRange(startDateStr, endDateStr, jadwalEksisting);
        tampilkanTanggalRangeCustomSharingSchedule(startDateStr, endDateStr, sharingSchedules);

        setTimeout(() => Swal.close(), 300);

    } catch (err) {
        console.error("❌ Gagal refresh jadwal:", err);
        Swal.fire({ icon: "error", title: "Gagal memuat jadwal", background: '#1e293b', color: '#ffffff' });
    }
}

export { refreshJadwalBulanAktif };

function cekSlotKosong(warnaSegment) {
    const slotLabel = [
        "00:00 - 05:59",
        "06:00 - 11:59",
        "12:00 - 17:59",
        "18:00 - 23:59",
    ];

    return warnaSegment
        .map((warna, index) =>
            warna === undefined || warna === "bg-white"
                ? slotLabel[index]
                : null,
        )
        .filter((v) => v !== null);
}

function tampilkanTanggalRangeCustomSharingSchedule(
    startDateStr,
    endDateStr,
    jadwalEksisting = [],
) {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const gridCustomSharingSchedule = document.getElementById("tanggalGridCustomSharingSchedule");
    endDate.setDate(endDate.getDate() + 1);
    gridCustomSharingSchedule.innerHTML = "";

    let lat = null;
    let lng = null;

    if (Array.isArray(jadwalEksisting) && jadwalEksisting.length > 0) {
        lat = parseFloat(jadwalEksisting[0].latitude);
        lng = parseFloat(jadwalEksisting[0].longitude);
    }

    // ===============================
    // Grouping pertama: city
    // ===============================
    const groupedByCity = {};
    jadwalEksisting.forEach((item) => {
        const city = item.company_main_city || "Unknown City";
        if (!groupedByCity[city]) groupedByCity[city] = [];
        groupedByCity[city].push(item);
    });

    const allDates = [];
    for (
        let d = new Date(startDate);
        d <= endDate;
        d.setDate(d.getDate() + 1)
    ) {
        allDates.push(new Date(d));
    }

    Object.entries(groupedByCity).forEach(([city, itemsInCity]) => {
        // Label kota
        const cityLabelDiv = document.createElement("div");
        cityLabelDiv.className = "text-sm font-bold text-gray-700 my-2";
        cityLabelDiv.textContent = city;
        gridCustomSharingSchedule.appendChild(cityLabelDiv);

        // ===============================
        // Grouping kedua: company_main_name
        // ===============================
        const groupedByCompany = {};
        itemsInCity.forEach((item) => {
            const companyName = item.company_main_name || "Unknown Company";
            if (!groupedByCompany[companyName])
                groupedByCompany[companyName] = [];
            groupedByCompany[companyName].push(item);
        });

        Object.entries(groupedByCompany).forEach(
            ([companyName, itemsInCompany]) => {
                // Label company
                const companyLabelDiv = document.createElement("div");
                companyLabelDiv.className =
                    "text-sm font-semibold text-indigo-700 ml-4 my-1";
                companyLabelDiv.textContent = companyName;
                gridCustomSharingSchedule.appendChild(companyLabelDiv);

                // ===============================
                // Grouping ketiga: plate_number
                // ===============================
                const groupedByPlate = {};
                itemsInCompany.forEach((item) => {
                    const plate = item.plate_number || "Tidak Diketahui";
                    if (!groupedByPlate[plate]) groupedByPlate[plate] = [];
                    groupedByPlate[plate].push(item);
                });

                Object.entries(groupedByPlate).forEach(
                    ([plate, tanggalArray]) => {
                        const rowDivCustomSharingSchedule =
                            document.createElement("div");
                        rowDivCustomSharingSchedule.className =
                            "flex gap-1 items-center relative ml-8";

                        const firstData = tanggalArray[0] || {};
                        const labelDiv = document.createElement("div");
                        labelDiv.className = `
                                min-w-[80px] max-w-[120px] text-xs sm:text-sm font-semibold text-gray-700
                                sticky left-0 bg-white z-10 border-r border-gray-200 plat-label
                                whitespace-nowrap
                            `;
                        labelDiv.innerHTML = `
                            <div class="text-[10px] font-medium text-blue-700 leading-snug tracking-tight flex items-center gap-1 overflow-hidden text-ellipsis whitespace-nowrap max-w-[100px]">
                                <i class="fas fa-car-side"></i> ${
                                    firstData.type_name || "-"
                                }
                            </div>
                            <div class="text-[9px] text-green-600 italic flex items-center gap-1">
                                <i class="fas fa-cogs"></i> ${
                                    firstData.transmission +
                                        " - " +
                                        firstData.year || "-"
                                }
                            </div>
                            <div class="text-[9px] font-bold text-gray-900">${plate}</div>
                        `;

                        const tanggalWrapper = document.createElement("div");
                        tanggalWrapper.className = `
                            flex items-start gap-[2px] w-max
                            px-1 pb-2
                        `;

                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        allDates.forEach((dateObj) => {
                            const tahun = dateObj.getFullYear();
                            const bulan = dateObj.getMonth() + 1;
                            const tanggal = dateObj.getDate();
                            const tanggalStr = `${tahun}-${String(
                                bulan,
                            ).padStart(2, "0")}-${String(tanggal).padStart(
                                2,
                                "0",
                            )}`;
                            const hari = dateObj.toLocaleDateString("id-ID", {
                                weekday: "long",
                            });
                            const isMinggu = hari === "Minggu";
                            const isLampau = dateObj < today;

                            const item = tanggalArray.find(
                                (item) => item.tanggal === tanggalStr,
                            );
                            const semuaDeliveryPadaTanggalIni =
                                tanggalArray.flatMap((i) => {
                                    const hasil = [];
                                    const orderDate = new Date(
                                        i.order_date || i.tanggal + " 00:01:00",
                                    );
                                    const deliveryDate = new Date(
                                        i.delivery_date,
                                    );
                                    const currentDate = new Date(tanggalStr);
                                    if (
                                        currentDate >= orderDate &&
                                        currentDate <= deliveryDate
                                    ) {
                                        hasil.push({
                                            jadwal_id: i.jadwal_id,
                                            order_date:
                                                orderDate
                                                    .toISOString()
                                                    .split("T")[0] +
                                                " " +
                                                (i.jam || "00:01:00"),
                                            delivery_date:
                                                deliveryDate
                                                    .toISOString()
                                                    .split("T")[0] +
                                                " 24:00:01",
                                            selisih_hari: i.selisih_hari,
                                            is_color: i.is_color,
                                            last_count: i.last_count,
                                        });
                                    }

                                    if (
                                        Number(i.selisih_hari) === 1 &&
                                        i.delivery_date.startsWith(tanggalStr)
                                    ) {
                                        hasil.push({
                                            jadwal_id: i.jadwal_id,
                                            order_date:
                                                i.delivery_date.split(" ")[0] +
                                                " 00:00:01",
                                            delivery_date: i.delivery_date,
                                            selisih_hari: i.selisih_hari,
                                            is_color: i.is_color,
                                            last_count: i.last_count,
                                        });
                                    }

                                    return hasil;
                                });

                            const warnaSegment =
                                getSegmentwarnaCustomSharingSchedule(
                                    semuaDeliveryPadaTanggalIni,
                                );
                            const semuaJadwalId = semuaDeliveryPadaTanggalIni
                                .map((i) => i.jadwal_id)
                                .join(",");
                            const lastCount = semuaDeliveryPadaTanggalIni
                                .map((i) => i.last_count)
                                .join(",");

                            const div = document.createElement("div");
                            const disabledClass = isLampau
                                ? "opacity-80 cursor-pointer"
                                : "cursor-pointer";

                            div.innerHTML = `
                                <div class="tanggal-item-custom-sharing-schedule relative w-[40px] h-[40px]
                                    text-center border border-gray-300 rounded-md
                                    overflow-hidden ${disabledClass}"
                                    data-id="${
                                        semuaJadwalId.split(",")[0] || ""
                                    }"
                                    data-tanggal="${tanggalStr}"
                                    data-lastCount="${lastCount}"
                                    data-carId="${
                                        item?.car_id || firstData.car_id || ""
                                    }">

                                    <div class="absolute top-0 left-0 w-1/4 h-full ${
                                        warnaSegment[0]
                                    }"></div>
                                    <div class="absolute top-0 left-1/4 w-1/4 h-full ${
                                        warnaSegment[1]
                                    }"></div>
                                    <div class="absolute top-0 left-2/4 w-1/4 h-full ${
                                        warnaSegment[2]
                                    }"></div>
                                    <div class="absolute top-0 left-3/4 w-1/4 h-full ${
                                        warnaSegment[3]
                                    }"></div>

                                    <div class="relative z-10 flex flex-col items-center justify-center w-full h-full p-0.5 transition-all duration-200 transform">
                                        <div class="text-xs md:text-[11px] font-semibold leading-none ${
                                            isMinggu
                                                ? "text-gray-900"
                                                : "text-gray-800"
                                        }">
                                            ${tanggal}
                                        </div>
                                        <div class="text-[9px] md:text-[8px] text-gray-500 leading-none ${
                                            isMinggu
                                                ? "text-gray-900"
                                                : "text-gray-800"
                                        }">
                                            ${hari}
                                        </div>
                                    </div>
                                </div>
                            `;

                            const tanggalItem = div.querySelector(
                                ".tanggal-item-custom-sharing-schedule",
                            );

                            tanggalItem.addEventListener("click", async (e) => {
                                const id = e.currentTarget.dataset.id;
                                const tgl = e.currentTarget.dataset.tanggal;
                                const lastCount =
                                    e.currentTarget.dataset.lastCount;
                                const idArray = id
                                    .split(",")
                                    .filter((item) => item.trim() !== "");
                                let htmlContent = `<div style="display: grid; grid-template-columns: 100px auto; gap: 8px; text-align: left;">`;
                                const firstData = tanggalArray[0] || {};
                                const companyId =
                                    firstData.company_main_id || null;
                                const companyCity =
                                    firstData.company_main_city || null;
                                const latitude = firstData.latitude || null;
                                const longitude = firstData.longitude || null;
                                companyIdMain = firstData.company_main_id || null;
                                companyCityMain = firstData.company_main_city || null;
                                latitudeMain = firstData.latitude || null;
                                longitudeMain = firstData.longitude || null;
                                fetchDrivers(companyId);
                                idArray.forEach((id, index) => {
                                    htmlContent += ``;
                                });
                                htmlContent += `</div>`;
                                const segments =
                                    e.currentTarget.querySelectorAll(
                                        "div.absolute",
                                    );
                                const warnaSegment = Array.from(segments).map(
                                    (seg) => {
                                        return seg.className
                                            .split(" ")
                                            .find((c) => c.startsWith("bg-"));
                                    },
                                );
                                const semuaMerah = warnaSegment.every(
                                    (w) => w === "bg-red-300",
                                );

                                // ✅ cek slot kosong
                                const slotKosong = cekSlotKosong(warnaSegment);
                                const fullSlots = [
                                    "00:00 - 05:59",
                                    "06:00 - 11:59",
                                    "12:00 - 17:59",
                                    "18:00 - 23:59",
                                ];

                                if (slotKosong.length > 0) {
                                    const isFullRange =
                                        slotKosong.length ===
                                            fullSlots.length &&
                                        slotKosong.every(
                                            (val, i) => val === fullSlots[i],
                                        );

                                    if (!isFullRange && !isLampau) {
                                        const { isConfirmed } = await Swal.fire(
                                            {
                                                title: "⏰ Slot Kosong",
                                                html: `Jam yang masih kosong:<br><br>${slotKosong.join(
                                                    "<br>",
                                                )}<br><br>Lanjutkan entri data?`,
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonText:
                                                    "Yes, lanjutkan",
                                                cancelButtonText: "No, batal",
                                            },
                                        );

                                        if (!isConfirmed) {
                                            return;
                                        }
                                    }
                                }

                                if (isLampau) {
                                    Swal.fire({
                                        title: "Tanggal sudah kadaluarsa",
                                        icon: "info",
                                        showConfirmButton: false,
                                        timer: 2000,
                                        timerProgressBar: true,
                                        width: "28rem",
                                        customClass: {
                                            popup: "rounded-lg shadow-md",
                                            title: "text-base font-medium whitespace-nowrap",
                                        },
                                    });
                                } else {
                                    const backupData = tanggalArray[0] || {};
                                    const mobilData = item || backupData;

                                    const dynamicMobil = {
                                        id: mobilData.car_id || null,
                                        name: mobilData.type_name || "-",
                                        transmission:
                                            mobilData.transmission || "-",
                                        plat: mobilData.plate_number || "-",
                                        year: mobilData.year || "-",
                                    };

                                    paramSimpan = 1;
                                    showModalPenjadwalan(
                                        "modalJadwal",
                                        id,
                                        lastCount,
                                        tgl,
                                        item || {},
                                        selectedMobil,
                                        dynamicMobil,
                                        companyCity,
                                        latitude,
                                        longitude,
                                        companyIdMain,
                                        paramSimpan,
                                    );
                                }
                            });

                            div.querySelector(
                                ".tanggal-item-custom-sharing-schedule",
                            ).addEventListener("click", () => {
                                tanggalWrapper
                                    .querySelectorAll(
                                        ".tanggal-item-custom-sharing-schedule",
                                    )
                                    .forEach((el) => {
                                        el.classList.remove(
                                            "border-b-4",
                                            "border-indigo-500",
                                            "ring-indigo-300",
                                        );
                                        el.classList.add("border-gray-300");
                                    });
                                div.querySelector(
                                    ".tanggal-item-custom-sharing-schedule",
                                ).classList.remove("border-gray-300");
                                div.querySelector(
                                    ".tanggal-item-custom-sharing-schedule",
                                ).classList.add(
                                    "border-b-4",
                                    "border-indigo-500",
                                    "ring-indigo-300",
                                );
                            });

                            tanggalWrapper.appendChild(div);
                        });

                        rowDivCustomSharingSchedule.appendChild(labelDiv);
                        rowDivCustomSharingSchedule.appendChild(tanggalWrapper);
                        gridCustomSharingSchedule.appendChild(
                            rowDivCustomSharingSchedule,
                        );
                    },
                );
            },
        );
    });

    toggleTanggalContainerCustomSharingSchedule("range");
}

function toggleTanggalContainerCustomSharingSchedule(mode) {
    const containerBulanCustomSharingSchedule = document.getElementById("tanggalContainerCustomSharingSchedule");
    const wrapperBulanCustomSharingSchedule = document.getElementById("tanggalWrapperCustomCustomSharingSchedule");
    containerBulanCustomSharingSchedule?.classList.remove("hidden");
    wrapperBulanCustomSharingSchedule?.classList.remove("hidden");
}

function getSegmentwarnaCustomSharingSchedule(datetime) {
    const warnaCustom = ["bg-white", "bg-white", "bg-white", "bg-white"];
    if (!datetime) return warnaCustom;

    let waktuListSharingSchedule = [];

    if (
        Array.isArray(datetime) &&
        typeof datetime[0] === "object" &&
        datetime[0] !== null
    ) {
        const adaMerahCustomSharingSchedule = datetime.some(
            (item) => Number(item.is_color) === 1,
        );
        if (adaMerahCustomSharingSchedule) {
            return ["bg-red-300", "bg-red-300", "bg-red-300", "bg-red-300"];
        }

        waktuListSharingSchedule = datetime.filter(
            (item) =>
                typeof item.order_date === "string" &&
                item.order_date.includes(" "),
        );
    } else if (Array.isArray(datetime)) {
        waktuListSharingSchedule = datetime
            .filter((item) => typeof item === "string" && item.includes(" "))
            .map((str) => ({ order_date: str, selisih_hari: 0 }));
    } else if (typeof datetime === "string") {
        waktuListSharingSchedule = parseDatetimeListCustomSharingSchedule(
            datetime,
        )
            .filter((item) => item.includes(" "))
            .map((str) => ({ order_date: str, selisih_hari: 0 }));
    } else {
        return warnaCustom;
    }

    waktuListSharingSchedule.forEach((item) => {
        const {
            order_date: orderDate,
            delivery_date: deliveryDate,
            is_color,
            selisih_hari,
            last_count,
        } = item;

        const spaceIndex = orderDate.indexOf(" ");
        if (spaceIndex === -1) return;

        const jamStr = orderDate.substring(spaceIndex + 1);
        const colonIndex = jamStr.indexOf(":");
        const jamOnly =
            colonIndex !== -1 ? jamStr.substring(0, colonIndex) : jamStr;
        const jamInt = parseInt(jamOnly);
        if (isNaN(jamInt)) return;
        const spaceIndexDelivery = deliveryDate?.indexOf(" ") ?? -1;
        if (spaceIndexDelivery === -1) return;
        const jamDeliveryStr = deliveryDate.substring(spaceIndexDelivery + 1);
        const colonIndexDelivery = jamDeliveryStr.indexOf(":");
        const jamDeliveryOnly =
            colonIndexDelivery !== -1
                ? jamDeliveryStr.substring(0, colonIndexDelivery)
                : jamDeliveryStr;
        const jamDeliveryInt = parseInt(jamDeliveryOnly);
        if (isNaN(jamDeliveryInt)) return;
        // Prioritas: is_color
        const preset = [
            "bg-gray-300",
            "bg-blue-300",
            "bg-yellow-300",
            "bg-purple-300",
        ];

        warnaCustom.fill("");

        if (is_color === 1) {
            warnaCustom.fill("bg-red-300");
        } else {
            const getSlot = (jam) => {
                if (jam >= 0 && jam < 6) return 0;
                if (jam >= 6 && jam < 12) return 1;
                if (jam >= 12 && jam < 18) return 2;
                if (jam >= 18 && jam <= 24) return 3;
                return -1;
            };

            if (last_count > 0) {
                const slot = getSlot(jamDeliveryInt);
                for (let i = 0; i <= slot; i++) {
                    warnaCustom[i] = preset[i];
                }
            } else {
                const start = getSlot(jamInt);
                const end = getSlot(jamDeliveryInt);
                for (let i = start; i <= end; i++) {
                    warnaCustom[i] = preset[i];
                }
            }
        }
    });

    return warnaCustom;
}

function parseDatetimeListCustomSharingSchedule(input) {
    const result = [];

    if (!input || typeof input !== "string") return result;

    let current = "";
    for (let i = 0; i < input.length; i++) {
        const char = input[i];
        if (char === ",") {
            if (current.trim()) result.push(current.trim());
            current = "";
        } else {
            current += char;
        }
    }
    if (current.trim()) result.push(current.trim());

    return result;
}

function formatDate(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
}

async function fetchDrivers(companyId) {
    try {
        const response = await fetch(
            `/penjadwalan/get-driver-company/${companyId}`,
        );
        const data = await response.json();
        const select = document.getElementById("nama_driver");
        const selectBulanan = document.getElementById(
            "nama_driver_jadwal_bulanan",
        );

        select.innerHTML = `
            <option value="">-- Pilih Driver --</option>
            <option value="0">Non Driver</option>
        `;

        selectBulanan.innerHTML = `
            <option value="">-- Pilih Driver --</option>
            <option value="0">Non Driver</option>
        `;

        if (data.success && Array.isArray(data.drivers)) {
            data.drivers.forEach((driver) => {
                const option1 = document.createElement("option");
                option1.value = driver.driver_id;
                option1.textContent = driver.user_name;

                const option2 = option1.cloneNode(true);

                select.appendChild(option1);
                selectBulanan.appendChild(option2);
            });
        }
    } catch (error) {
        console.error("Gagal load driver:", error);
    }
}

export function resetModalJadwal() {
    const formIds = ['data_customer_form', 'data_customer_form_lepas', 'data_customer_form_bulanan'];

    formIds.forEach(id => {
        const form = document.getElementById(id);
        if (form) form.reset();
    });
    const contentIds = ['contentPlus', 'contentBulanan', 'contentLepas'];
    contentIds.forEach(id => {
        const content = document.getElementById(id);
        if (content) content.classList.add('hidden');
    });
    const ordersList = document.getElementById('orders-list');
    if (ordersList) ordersList.innerHTML = '';
    const carTypeId = document.getElementById('car_type_id');
    if (carTypeId) carTypeId.value = '';
    const modalBody = document.querySelector('#modalJadwal .overflow-y-auto');
    if (modalBody) modalBody.scrollTop = 0;

    console.log("Modal Jadwal telah direset.");
}

document
    .querySelectorAll('.additional-cost-checkbox')
    .forEach(cb => {

        const card = cb.closest('.cost-card');
        const check = card.querySelector('.cost-check');
        const icon = check.querySelector('svg');

        const updateState = () => {

            if (cb.checked) {

                card.classList.add(
                    'border-indigo-500',
                    'bg-indigo-50'
                );

                check.classList.add(
                    'bg-indigo-600',
                    'border-indigo-600'
                );

                icon.classList.remove('hidden');

            } else {

                card.classList.remove(
                    'border-indigo-500',
                    'bg-indigo-50'
                );

                check.classList.remove(
                    'bg-indigo-600',
                    'border-indigo-600'
                );

                icon.classList.add('hidden');
            }
        };

        updateState();
        cb.addEventListener('change', updateState);
    });
